module.exports = __webpack_public_path__ + "static/maps@2x-6b69dee4aedd65d97b88cc97a1053730.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/wireframing/maps@2x.png
// module id = 2623
// module chunks = 168707334958949